<template>
  <div class="position-relative mt-3" id="packagediscountsTable">
    <div class="actions text-right" id="packagediscountsTable-showAddEditDialog">
      <button class="btn btn-primary icon-button" aria-label="Add" @click="showAddEditDialog = true"
        id="packagediscountsTable-add-Button">
        <span class="btn-icon" id="packagediscountsTable-addButton-span">
          <i class="fa fa-plus" aria-hidden="true" id="packagediscountsTable-addButton-data"></i>
        </span>
        {{ 'ADD' | translate }}
      </button>
    </div>

    <vodal :show="showAddEditDialog" :width="400" :closeOnEsc="true" :closeOnClickMask="false"
      :customStyles="{ 'top': '80px', 'bottom': 'auto', 'height': 'auto' }" animation="rotate" @hide="closeDialog">
      <package-discounts-add-edit-dialogue
        ref="addEditDialogue"
        :edited="editedRow"
        @save="onSaveNew"
        @update="onUpdate"
        @close="closeDialog"
        :errortype="error"
        id="packagediscountsTable-addEditDialog">
      </package-discounts-add-edit-dialogue>
    </vodal>
    
    <table class="table table-striped table-hover" id="packagediscountsTable-tableData">
      <caption class="sr-only">Package discounts with no of policies and discount percentages</caption>
      <tr>
        <th>{{ 'NAME' | translate }}</th>
        <th>{{ 'No_Of_Policies' | translate }}</th>
        <th>{{ 'DiscountPercentage' | translate }}</th>
      </tr>
      <tr v-for="row in rows" :key="row.code">
        <td>{{ row.name }}</td>
        <td>
          <div v-for="(myentry, index) in row.entries" :key="index" class="apiValueIncoming-item">
            {{ myentry.noOfPolicies }}
          </div>
        </td>
        <td>
          <div v-for="(myentry, index) in row.entries" :key="index" class="apiValueIncoming-item">
            {{ myentry.discountPercentage | discountFormat }}
          </div>
        </td>
        <td id="packagediscountsTable-tableButtons">
          <button class="btn btn-success icon-button icon-button-collapsed"
            v-tooltip="$options.filters.translate('EDIT')" aria-label="Edit" @click="onEdit(row)"
            :id="'packagediscountsTable-tableEditButton-' + row.name">
            <span class="btn-icon" :id="'packagediscountsTable-tableEditSpan-' + row.name">
              <i class="fa fa-pencil" aria-hidden="true"
                :id="'packagediscountsTable-tableEditData-' + row.name"></i>
            </span>
          </button>
          <button class="btn btn-danger icon-button icon-button-collapsed"
            v-tooltip="$options.filters.translate('DELETE')" aria-label="Delete" @click="confirmDelete(row)"
            :id="'packagediscountsTable-tableDeleteButton' + row.name">
            <span class="btn-icon" :id="'packagediscountsTable-tableDeleteSpan-' + row.name">
              <i class="fa fa-trash-o" aria-hidden="true"
                :id="'packagediscountsTable-tableDeleteData-' + row.name"></i>
            </span>
          </button>
        </td>
      </tr>
    </table>
    <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
      @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.code)">
    </confirm-dialog>
  </div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import PackageDiscountsAddEditDialogue from './PackageDiscountsAddEditDialogue.vue';
import Vodal from 'vodal';
import ConfirmDialog from '../../dialog/ConfirmDialog.vue';
import KeycloakService from '../../../service/keycloak/KeycloakService';

export default {
  components: { PackageDiscountsAddEditDialogue, Vodal, ConfirmDialog },
  data() {
    return {
      rest: this.initRestService(),
      filter: '',
      rows: [],
      editedRow: null,
      showAddEditDialog: false,
      showDeleteConfirmDialog: false,
      selectedRow: null,
      error: null
    }
  },
  beforeMount() {
    this.loadRows();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadRows() {
      const packagediscountsResponse = await this.rest.getAllPackagediscountsRows();
      this.rows = packagediscountsResponse.data;
    },
    async onSaveNew(row) {
      try {
        await this.rest.createPackagediscountsRow(row);
        this.closeDialog();
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.setError('ERROR_DUPLICATE_RECORD_LINE');
        } else {
          this.setError('ERROR_DURING_OPERATION');
        }
        this.$log.error(error.response ? error.response.data : error);
      }
    },
    async onUpdate(row) {
      try {
        await this.rest.updatePackagediscountsRow(row);
        this.closeDialog();
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.setError('ERROR_DUPLICATE_RECORD_LINE');
        } else {
          this.setError('ERROR_DURING_OPERATION');
        }
        this.$log.error(error.response ? error.response.data : error);
      }
    },
    onEdit(row) {
      this.editedRow = { ...row };
      this.showAddEditDialog = true;
    },
    onRemove(rowId) {
      try {
        this.rows = this.rows.filter(row => row.code !== rowId);
        this.rest.deletePackagediscountsRow(rowId);
        this.showDeleteConfirmDialog = false;
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.setError('ERROR_DUPLICATE_RECORD_LINE');
        } else {
          this.setError('ERROR_DURING_OPERATION');
        }
        this.$log.error(error.response ? error.response.data : error);
      }
      this.rows = this.rows.filter(row => row.code !== rowId);
      this.rest.deletePackagediscountsRow(rowId);
      this.showDeleteConfirmDialog = false;
    },
    closeDialog() {
      this.showAddEditDialog = false;
      this.editedRow = false;
      if (this.$refs.addEditDialogue) {
        this.$refs.addEditDialogue.resetPackageDiscounts();
      }
      this.loadRows();
    },
    confirmDelete(row) {
      this.selectedRow = row;
      this.showDeleteConfirmDialog = true;
    },
    setError(errorMessage) {
      this.error = errorMessage;
      setTimeout(() => {
        this.error = false;
      }, 5000);
    }
  },
  filters: {// Vue 3 deprecates filters please move discountFormat to a method/computed (complete this change in vue3 code migration)
    discountFormat(value) {
      const lang = KeycloakService.getLanguage();
      let formattedValue = value;
      if (typeof value === 'number') {
        formattedValue = value.toFixed(2);
      }
      if (lang === 'nl' && typeof formattedValue === 'string') {
        return formattedValue.replace('.', ',');
      }
      return formattedValue;
    }
  }
}
</script>

<style lang="scss" scoped>
>>>.vue-table {
  border: 0;

  th,
  td {
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
  }

  thead > tr > th {
    padding-right: .75rem;
    padding-left: 30px !important;
  }

  .arrow:before {
    bottom: 12px;
    right: auto;
    left: 12px;
    font-family: 'FontAwesome', sans-serif;
  }

  .icon-button {
    opacity: 0;
    transition: opacity .1s ease-out;
  }

  tr:hover .icon-button {
    opacity: 1;
  }
}

.actions {
  position: absolute;
  z-index: 1;
  top: 10px;
  right: 0;

  .icon-button {
    padding-right: 15px;
    padding-left: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/PackageDiscounts/PackageDiscountsTable.vue